import React from "react";
import {EntityLayout} from "../../../entity/EntityLayout/EntityLayout";
import {EntityHeaderBreadcrumbs} from "../../../entity/EntityHeaderBreadcrumbs/EntityHeaderBreadcrumbs";
import {Link, TableColumn} from "@backstage/core-components";
import {CatalogTableRow} from "@backstage/plugin-catalog";
import {createNameColumn, createOwnerColumn} from "../../../entity/utils/tableColumns";
import {isMobile} from "mobile-device-detect";
import {SchemaEntity, SchemaEntityConfig} from "./types";
import OverviewContent from "./tabs/OverviewContent";
import DefinitionContent from "./tabs/DefinitionContent";
import OpenAPIContent from "./tabs/OpenAPIContent";
import GoDocContent from "./tabs/GoDocContent";

export const createSchemaEntityTableLinksColumn = (
  config: SchemaEntityConfig,
  width?: string
): TableColumn<CatalogTableRow> => {
  return {
    title: 'Links',
    render: ({entity}) => {
      const schemaEntity = entity as SchemaEntity;
      return (
        <ul>
          <li>
            <Link
              to={`https://github.com/weave-lab/schema/tree/main/${config.sourcePath}/${schemaEntity.spec?.schema?.path}`}>
              Source
            </Link>
          </li>
        </ul>
      );
    },
    width: width,
  };
};

export const getSchemaEntityTableColumns = (
  config: SchemaEntityConfig
): TableColumn<CatalogTableRow>[] => {
  let columns: TableColumn<CatalogTableRow>[] = [
    createNameColumn({width: "20%"}),
    createOwnerColumn("30%"),
  ];

  if (!isMobile) {
    columns.push(createSchemaEntityTableLinksColumn(config, "20%"));
  }

  return columns;
};

interface SchemaEntityPageProps {
  config: SchemaEntityConfig;
}

const SchemaEntityPage = ({config}: SchemaEntityPageProps) => {
  return (
    <EntityLayout headerRoutingBreadcrumbs={<EntityHeaderBreadcrumbs/>}>
      <EntityLayout.Route path="/" title="Overview">
        <OverviewContent config={config}/>
      </EntityLayout.Route>
      <EntityLayout.Route path="/definition" title="Definition">
        <DefinitionContent/>
      </EntityLayout.Route>
      <EntityLayout.Route path="/openapi" title="OpenAPI">
        <OpenAPIContent/>
      </EntityLayout.Route>
      <EntityLayout.Route path="/godocs" title="GoDocs">
        <GoDocContent config={config}/>
      </EntityLayout.Route>
    </EntityLayout>
  );
};

export default SchemaEntityPage;
